export default __webpack_public_path__ + "8f93cba84b07154aefc8a59813a84c4b.woff";